import React, { useEffect, useState } from 'react'
import Footer from '../Components/Footer';
import Auth from '../Function/Auth';
import Header from '../Components/Header';
import { ToastContainer, toast } from 'react-toastify';

function Trade() {

    const authToken = sessionStorage.getItem('authToken');
    const baseurl = process.env.REACT_APP_BASE_API_URL;

    const [analytics, setAnalytics] = useState({});
    const [tableLoading, setTableLoading] = useState(false);
    const [stakes, setStakes] = useState([]);
    const [pagination, setPagination] = useState({});

    const [user_id, setUserID] = useState("");
    const [stake_asset, setStakeAsset] = useState("");
    const [status, setStatus] = useState("");
    const [tradeData, setTradedata] = useState([]);
    const [remark, setRemark] = useState('');
    const [isProcessing, setIsProcessing] = useState(false);
    const [remarkError, setRemarkError] = useState('');

    useEffect(() => {
        fetchStakeData(1);

        // Cleanup function for modal on unmount
        return () => {
            const modalElement = document.getElementById('modaldemo8');
            if (modalElement) {
                const modal = window.bootstrap.Modal.getInstance(modalElement);
                if (modal) {
                    modal.dispose();
                }
                // Clean up any remaining backdrop
                const backdrop = document.querySelector('.modal-backdrop');
                if (backdrop) {
                    backdrop.remove();
                }
                document.body.classList.remove('modal-open');
                document.body.style.removeProperty('overflow');
                document.body.style.removeProperty('padding-right');
            }
        };
    }, []);

    const fetchStakeData = async (page) => {

        const searchData = {
            page: page,
            user_id: user_id,
            stake_asset: stake_asset,
            status: status
        };

        try {
            const res = await fetch(`${baseurl}/client/stakes`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${authToken}`,
                },
                body: JSON.stringify(searchData),
            });

            const result = await res.json();

            if (result.status) {
                setAnalytics(result.analytics);
                setStakes(result.data);
                setPagination(result.pagination);
                setTableLoading(true);
            } else {
                setTableLoading(true);
            }

        } catch (error) {
            console.error(error);
        }
    };

    const handlePageChange = (page) => {
        setTableLoading(false);
        fetchStakeData(page);
    };

    const searchDataHandler = () => {
        setTableLoading(false);
        fetchStakeData(1);
    };


    const approveTrade = async (data) => {
        // Validate remark is required
        if (!remark.trim()) {
            setRemarkError('Remark is required for ' + data);
            toast.error('Please enter a remark before ' + (data === 'approve' ? 'approving' : 'rejecting'));
            return;
        }

        setRemarkError('');
        setIsProcessing(true);

        const formData = {
            stake_id: tradeData.id,
            type: data,
            remark: remark.trim(),
        };

        try {
            const res = await fetch(`${baseurl}/client/approve-stake`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${authToken}`,
                },
                body: JSON.stringify(formData),
            });

            const result = await res.json();

            if (result.status) {
                toast.success(`Trade ${data === 'approve' ? 'approved' : 'rejected'} successfully!`);

                // Reset form
                setRemark('');
                setTradedata([]);

                // Close modal properly
                const modalElement = document.getElementById('modaldemo8');
                const modal = window.bootstrap.Modal.getInstance(modalElement);
                if (modal) {
                    modal.hide();

                    // Remove backdrop manually if it exists
                    setTimeout(() => {
                        const backdrop = document.querySelector('.modal-backdrop');
                        if (backdrop) {
                            backdrop.remove();
                        }
                        // Remove modal-open class from body
                        document.body.classList.remove('modal-open');
                        document.body.style.removeProperty('overflow');
                        document.body.style.removeProperty('padding-right');
                    }, 150);
                }

                // Refresh the table data
                fetchStakeData(pagination.current_page || 1);
            } else {
                toast.error(result.message || `Failed to ${data} trade`);
            }

        } catch (error) {
            console.error(error);
            toast.error(`Error occurred while ${data === 'approve' ? 'approving' : 'rejecting'} trade`);
        } finally {
            setIsProcessing(false);
        }
    }

    const openModal = (data) => {
        setTradedata(data);
        setRemark('');
        setRemarkError('');
    }

    const closeModalProperly = () => {
        // Clean up modal state
        setRemark('');
        setRemarkError('');

        // Ensure backdrop is removed
        setTimeout(() => {
            const backdrop = document.querySelector('.modal-backdrop');
            if (backdrop) {
                backdrop.remove();
            }
            document.body.classList.remove('modal-open');
            document.body.style.removeProperty('overflow');
            document.body.style.removeProperty('padding-right');
        }, 150);
    }

    return (
        <>
            <Header>
                <Auth />
                <div className="main-content app-content" >
                    <div className="container-fluid">
                        {/* Page Header */}
                        <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
                            <div>
                                <h4 className="mb-0">Trades!</h4>

                            </div>
                        </div>
                        {/* End Page Header */}

                        {/* row */}
                        <div className="row">
                            <div className="col-xl-6 col-lg-6 col-md-6 col-xm-12">
                                <div className="card overflow-hidden sales-card bg-primary-gradient">
                                    <div className="px-3 pt-3  pb-2 pt-0">
                                        <div>
                                            <h6 className="mb-3 fs-12 text-fixed-white">TOTAL TRADES</h6>
                                        </div>
                                        <div className="pb-0 mt-0">
                                            <div className="d-flex">
                                                <div>
                                                    <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                                                        {analytics ? analytics.total_no_of_stakes : '0'}

                                                    </h4>
                                                    <p className="mb-0 fs-12 text-fixed-white op-7">
                                                        Trade Value
                                                    </p>
                                                </div>
                                                <span className="float-end my-auto ms-auto">

                                                    <h5 className="text-fixed-white op-7"> ${Number(analytics ? analytics.total_stake_value : 0).toFixed(2)}
                                                    </h5>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="compositeline" />
                                </div>
                            </div>

                            <div className="col-xl-6 col-lg-6 col-md-6 col-xm-12">
                                <div className="card overflow-hidden sales-card bg-danger-gradient">
                                    <div className="px-3 pt-3  pb-2 pt-0">
                                        <div>
                                            <h6 className="mb-3 fs-12 text-fixed-white">CLOSED TRADES</h6>
                                        </div>
                                        <div className="pb-0 mt-0">
                                            <div className="d-flex">
                                                <div>
                                                    <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                                                        {analytics ? analytics.total_completed_stakes : '0'}
                                                    </h4>
                                                    <p className="mb-0 fs-12 text-fixed-white op-7">
                                                        CLOSED VALUE
                                                    </p>
                                                </div>
                                                <span className="float-end my-auto ms-auto">

                                                    <h5 className="text-fixed-white op-7"> ${Number(analytics ? analytics.completed_stake_value : 0).toFixed(2)}</h5>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="compositeline2" />
                                </div>
                            </div>
                        </div>


                        <div className="row">
                            <div className="col-md-12 col-lg-12 col-xl-12">
                                <div className="card card-table">
                                    <div className=" card-header p-0 d-flex justify-content-between mt-3">
                                        <h3 className="card-title mb-1 text-primary">Trade History</h3>
                                    </div>
                                    <div className="table-responsive country-table">
                                        {tableLoading ? (
                                            <table className="table table-striped table-bordered mb-0 text-nowrap mt-3" >

                                                <thead>
                                                    <tr>
                                                        <th className="wd-lg-25p">User</th>
                                                        <th className="wd-lg-25p">User Name</th>
                                                        <th className="wd-lg-25p">Trade Amount</th>
                                                        <th className="wd-lg-25p">Monthly Reward</th>
                                                        <th className="wd-lg-25p">Age</th>
                                                        <th className="wd-lg-25p">Last Credit</th>
                                                        <th className="wd-lg-25p">Total Credit</th>
                                                        <th className="wd-lg-25p">Date Time</th>
                                                        <th className="wd-lg-25p">STATUS</th>
                                                        <th className="wd-lg-25p">Action</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {stakes.length > 0 ? (
                                                        stakes.map((depositData, index) => (
                                                            <tr key={index}>
                                                                <td> <img className="rounded-circle" width={37} src={depositData.profile_image || 'https://apiuser.ride2luxury.in/images/profileImage/avtarImage-1.avif'} /></td>
                                                                <td> {depositData.user_name || 'N/A'} </td>
                                                                <td> ${depositData.stake_amount || '0'} </td>
                                                                <td> {depositData.daily_reward_percentage || 'N/A'} % </td>
                                                                <td> {depositData.stake_age || 'N/A'} Days </td>
                                                                <td> ${depositData.daily_credit_reward || '0'} </td>
                                                                <td> ${depositData.total_credit || '0'}</td>
                                                                <td> {depositData.date_time || 'N/A'} </td>
                                                                <td>
                                                                    {depositData && depositData.status
                                                                        ? depositData.status === 'success' ? (
                                                                            <span className="badge bg-success">success</span>
                                                                        ) : (
                                                                            <span className="badge bg-danger">{depositData.status} </span>
                                                                        ) : 'N/A'}
                                                                </td>
                                                                <td>
                                                                    <button className="btn btn-primary btn-sm" onClick={() => openModal(depositData)} data-bs-toggle="modal" data-bs-target="#modaldemo8">
                                                                        <i className="fa fa-eye"></i>
                                                                    </button>
                                                                </td>

                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td>No Data Found</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <div className="text-center">
                                                <div className="d-flex justify-content-center mb-4">
                                                    <div className="spinner-border" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}


                                    </div>
                                    <div className="gridjs-footer">
                                        <div className="gridjs-pagination">
                                            <div role="status" aria-live="polite" className="gridjs-summary" title="Page 1 of 1">Showing <b>{pagination.current_page}</b> to <b>{pagination.per_page}</b> of <b>{pagination.total}</b> results</div>
                                            <div className="gridjs-pages text-end">
                                                {/* Previous Button */}
                                                <button tabIndex="0" role="button" title="Previous" aria-label="Previous" className={pagination.current_page === 1 ? "disabled" : ""} onClick={() => handlePageChange(pagination.current_page - 1)} disabled={pagination.current_page === 1}> Previous</button>

                                                {/* First Page */}
                                                <button tabIndex="0" role="button" className={` ${pagination.current_page === 1 ? "gridjs-currentPage" : ""}`} title="Page 1" aria-label="Page 1" onClick={() => handlePageChange(1)}> 1</button>

                                                {/* Ellipsis if needed */}
                                                {pagination.current_page > 3 && <span>...</span>}

                                                {/* Middle Pages (2 dynamic pages around current) */}
                                                {Array.from({ length: 5 }, (_, i) => {
                                                    const page = pagination.current_page - 2 + i;
                                                    if (page > 1 && page < pagination.last_page) {
                                                        return (
                                                            <button key={page} tabIndex="0" role="button" className={` ${pagination.current_page === page ? "gridjs-currentPage" : ""}`} title={`Page ${page}`}
                                                                aria-label={`Page ${page}`} onClick={() => handlePageChange(page)}>
                                                                {page}
                                                            </button>
                                                        );
                                                    }
                                                    return null;
                                                })}

                                                {/* Ellipsis if needed */}
                                                {pagination.current_page < pagination.last_page - 2 && <span>...</span>}

                                                {/* Last Page */}
                                                {pagination.last_page > 1 && (
                                                    <button tabIndex="0" role="button" className={` ${pagination.current_page === pagination.last_page ? "gridjs-currentPage" : ""}`} title={`Page ${pagination.last_page}`} aria-label={`Page ${pagination.last_page}`}
                                                        onClick={() => handlePageChange(pagination.last_page)}>
                                                        {pagination.last_page}
                                                    </button>
                                                )}

                                                {/* Next Button */}
                                                <button tabIndex="0" role="button" title="Next" aria-label="Next" className={pagination.current_page === pagination.last_page ? "disabled" : ""} onClick={() => handlePageChange(pagination.current_page + 1)} disabled={pagination.current_page === pagination.last_page}>
                                                    Next
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>




                    </div>
                </div>


                <div className="modal fade" id="modaldemo8">
                    <div className="modal-dialog  modal-dialog-centered text-center" role="document">
                        <div className="modal-content modal-content-demo">
                            <div className="modal-header">
                                <h6 className="modal-title">Trade Details</h6>
                                <button aria-label="Close" className="btn-close" data-bs-dismiss="modal" onClick={closeModalProperly}></button>
                            </div>
                            <div className="modal-body">
                                <div className="d-flex p-3 border-top">
                                    <label>
                                        <span><b className="text-primary">User Name</b></span>
                                    </label>
                                    <span className="ms-auto">{tradeData ? tradeData?.user_name : ''}</span>
                                </div>

                                <div className="d-flex p-3 border-top">
                                    <label>
                                        <span><b className="text-primary">Trade Amount</b></span>
                                    </label>
                                    <span className="ms-auto">${tradeData ? tradeData?.stake_amount : 0}</span>
                                </div>

                                <div className="d-flex p-3 border-top">
                                    <label>
                                        <span><b className="text-primary">Deposit  Address</b></span>
                                    </label>
                                    <span className="ms-auto">{tradeData ? tradeData?.to_address : 0}</span>
                                </div>


                                <div className="d-flex p-3 border-top">
                                    <label>
                                        <span><b className="text-primary">Txn Hash </b></span>
                                    </label>
                                    <span className="ms-auto">{tradeData ? tradeData?.txn_hash : 0}</span>
                                </div>

                                <div className="d-flex p-3 border-top">
                                    <label>
                                        <span><b className="text-primary">Monthly Reward</b></span>
                                    </label>
                                    <span className="ms-auto">{tradeData ? tradeData?.daily_reward_percentage : 0}%</span>
                                </div>

                                <div className="d-flex p-3 border-top">
                                    <label>
                                        <span><b className="text-primary">Age</b></span>
                                    </label>
                                    <span className="ms-auto">{tradeData ? tradeData?.stake_age : 0} Days</span>
                                </div>

                                <div className="d-flex p-3 border-top">
                                    <label>
                                        <span><b className="text-primary">Last Credit</b></span>
                                    </label>
                                    <span className="ms-auto">${tradeData ? tradeData?.daily_credit_reward : 0}</span>
                                </div>

                                <div className="d-flex p-3 border-top">
                                    <label>
                                        <span><b className="text-primary">Total Credit</b></span>
                                    </label>
                                    <span className="ms-auto">${tradeData ? tradeData?.total_credit : 0}</span>
                                </div>

                                <div className="d-flex p-3 border-top">
                                    <label>
                                        <span><b className="text-primary">Trade Date</b></span>
                                    </label>
                                    <span className="ms-auto">{tradeData ? tradeData?.date_time : 'N/A'}</span>
                                </div>

                                <div className="d-flex p-3 border-top">
                                    <label>
                                        <span><b className="text-primary">Last Update</b></span>
                                    </label>
                                    <span className="ms-auto">{tradeData ? tradeData?.last_update : 'N/A'}</span>
                                </div>

                                <div className="d-flex p-3 border-top">
                                    <label>
                                        <span><b className="text-primary">Status</b></span>
                                    </label>
                                    {tradeData && tradeData.status
                                        ? tradeData.status === 'success' ? (
                                            <span className=" ms-auto badge bg-success">success</span>
                                        ) : (
                                            <span className=" ms-auto badge bg-danger">{tradeData.status} </span>
                                        ) : 'N/A'}
                                </div>

                                <div className="p-3 border-top">
                                    <label className="d-block text-start mb-2">
                                        <span><b className="text-primary">Remark <span className="text-danger">*</span></b></span>
                                    </label>
                                    <textarea
                                        className={`form-control ${remarkError ? 'is-invalid' : ''}`}
                                        rows="3"
                                        placeholder="Enter remark (required)"
                                        value={remark}
                                        onChange={(e) => { setRemark(e.target.value); setRemarkError(''); }}
                                        disabled={isProcessing}
                                    />
                                    {remarkError && <div className="invalid-feedback d-block">{remarkError}</div>}
                                </div>

                                <div className="d-flex justify-content-center gap-3 p-3 border-top">
                                    <button
                                        className="btn btn-success px-4"
                                        onClick={() => approveTrade('approve')}
                                        disabled={isProcessing}
                                    >
                                        {isProcessing ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                Processing...
                                            </>
                                        ) : 'Approve'}
                                    </button>
                                    <button
                                        className="btn btn-danger px-4"
                                        onClick={() => approveTrade('reject')}
                                        disabled={isProcessing}
                                    >
                                        {isProcessing ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                Processing...
                                            </>
                                        ) : 'Reject'}
                                    </button>
                                </div>




                            </div>

                            <div className="modal-footer">
                                <button className="btn btn-secondary" data-bs-dismiss="modal" onClick={closeModalProperly}>Close</button>
                            </div>

                        </div>
                    </div>
                </div>



                <ToastContainer />
            </Header>

            <Footer />
        </>
    );
}

export default Trade;